import { Component, OnInit } from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '../../../store/app.states';
import {DateAdapter} from '@angular/material/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {User} from '../../../model/user/User';
import {SettingsService} from '../../../services/settings.service';
import {EditForm} from '../../../model/user/EditForm';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ErrorDialogComponent} from '../../user-actions/error-dialog/error-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {MatSlideToggleChange} from "@angular/material/slide-toggle";

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {


  title = 'Impostazioni';
  user: User | null;
  back = true;
  destination = '/landing';
  editing = false;
  editingForm: FormGroup;
  notFocused = false;
  birthDate: string;
  isNotifyEnabled = true;

  constructor(private settingsService: SettingsService,
              private store: Store<AppState>,
              private dateAdapter: DateAdapter<Date>,
              private snackBar: MatSnackBar,
              private dialog: MatDialog) {
    this.dateAdapter.setLocale('it');
  }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.isNotifyEnabled = this.user.chatNotificationEnabled;
    const date = new Date(this.user.birthDate);
    this.birthDate = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
    this.setup();
  }

  setup() {
    this.editingForm = new FormGroup({
      name: new FormControl(this.user.name, [Validators.required]),
      surname: new FormControl(this.user.surname, [Validators.required]),
      ssn: new FormControl(this.user.ssn , []),
      phoneNumber: new FormControl(this.user.phoneNumber, [Validators.required]),
      birthDate: new FormControl(this.user.birthDate, []),
      birthPlace: new FormControl(this.user.birthPlace, [Validators.required]),
    });
  }

  modify() {
    this.editing = true;
    this.editingForm.get('ssn').disable();
  }

  setDate($event: MatDatepickerInputEvent<any>) {
    this.birthDate =
      $event.target._dateAdapter.getDate($event.target.value).toString(10) + '/' +
      ($event.target._dateAdapter.getMonth($event.target.value) + 1).toString(10) + '/' +
      $event.target._dateAdapter.getYear($event.target.value).toString(10);
  }

  onSubmit(value) {
    this.editing = false;
    // tslint:disable-next-line:max-line-length
    const editForm = new EditForm(this.user.email, value.name, value.surname, value.phoneNumber, this.birthDate, value.birthPlace);
    this.settingsService.editProfile(editForm).subscribe(res => {
      if (res.status === 200) {
        this.openSnackBar('Informazioni modificate con successo!', 'Chiudi');
        localStorage.setItem('user', JSON.stringify(res.body));
        this.user = res.body;
      }
    },
      error => {
        console.log(error);
        this.openErrorDialog('Qualcosa è andato storto. Le modifiche non verranno salvate.');
      });
  }

  openErrorDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }

  toggle(event: MatSlideToggleChange) {
    this.settingsService.updateChatNotification(event.checked).subscribe(x => {
      this.user.chatNotificationEnabled = event.checked;
      localStorage.setItem('user', JSON.stringify(this.user))
      }
      , error =>  {
            if (error.status === 500) {
              localStorage.setItem('expirationTime', '0');
              console.log('sessione scaduta');
              location.reload();
            }
    });
  }
}
